module.exports = __webpack_public_path__ + "images/8ced9973be696e7320bdda1d1f4b793b.svg";